<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
	<nk-box
		v-if="context && context.fachbereich && context.fachbereich.name"
		variant="sidebar"
	>
		<nk-title size="lg">
			{{ context.fachbereich.name }}
		</nk-title>

		<template v-if="context.info">
			<nk-title size="base">
				{{ context.info.titel }}
			</nk-title>
			<nk-text size="sm" v-html="context.info.text" />
			<nk-divider />
		</template>

		<div
			v-if="
				context.fachbereich.oeffnungszeiten &&
				context.fachbereich.oeffnungszeiten.text
			"
			class="nk-cms-content"
			v-html="context.fachbereich.oeffnungszeiten.text"
		/>
	</nk-box>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 * @prop {object} context.fachbereich
 */
export default {
	name: 'NkSidebarServiceBwFachbereich',

	mixins: [TemplatesDefault],
};
</script>
